import React from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "./Breadcrumbs";
import { Link } from "react-router-dom";
import { AppLogo } from "../svg/Index";

export type IFooterProps = {
  isAuthenticated: boolean;
};
const Footer: React.FC<IFooterProps> = (props) => {
  const { isAuthenticated } = props;
  const { t } = useTranslation();
  return (
    <><Breadcrumbs />
      <footer className="app-footer">
        <div>
          <div className="footer-copyright">
            <span>{t("common.footer_text")}</span>
          </div></div>
      </footer></>
  );
};

export default Footer;
